import { Component, OnInit, computed, inject, signal } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { filter } from 'rxjs';

import { Types } from '../../../domain/types.domain';
import { buildSelectCityOptions, SelectCityOption } from '../../utils/public-city-list';

import { CityRepositoryInstruction } from '../../../builder/instructions/repositories/city.repository.instructions';
import { GetPublicCityListServiceInstruction } from '../../../builder/instructions/services/get-public-city-list.service.instruction';

@Component({
  selector: 'app-select-city',
  standalone: true,
  imports: [ReactiveFormsModule],
  providers: [
    new CityRepositoryInstruction(),
    new GetPublicCityListServiceInstruction(),
  ],
  templateUrl: './select-city.component.html',
  styleUrl: './select-city.component.scss',
})
export class SelectCityComponent implements OnInit {
  private readonly router = inject(Router);
  private readonly route = inject(ActivatedRoute);
  private readonly _settings = inject(Types.Settings);
  private readonly _getPublicCityListService = inject(Types.GetPublicCityListService);

  public citiesList = signal<SelectCityOption[]>(buildSelectCityOptions(null, this._settings.citiesWhitelist));
  public listSorted = computed(() => [...this.citiesList()].sort((a, b) => a.name.localeCompare(b.name)));
  public cityFormControl = new FormControl('');

  ngOnInit(): void {
    void this._loadCities();

    this.cityFormControl.valueChanges
      .pipe(filter(Boolean))
      .subscribe((value) => {
        const city = this.citiesList().find((city) => city.identity === value);
        if (city?.loginUrl) {
          window.location.href = city.loginUrl;
          return;
        }

        this.router.navigate([`/${value}`]);
      });
  }

  private async _loadCities(): Promise<void> {
    if ((this._settings as { dynamicTenantResolution?: boolean }).dynamicTenantResolution !== true) {
      return;
    }

    // `?includeInternal=true` na URL mostra também as cidades internas (demos, sandboxes),
    // que a API omite por padrão: o seletor sem parâmetro é o do cliente.
    const includeInternal = this.route.snapshot.queryParamMap.get('includeInternal') === 'true';
    const apiCities = await this._getPublicCityListService
      .handle({ includeInternal })
      .catch(() => null);
    this.citiesList.set(buildSelectCityOptions(apiCities, this._settings.citiesWhitelist));
  }
}
